@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

@height-of-left-side-footer: 89px;

.base-left {
  height: calc(100% - @height-of-left-side-footer);
}

.base-right {
  height: 100%;
}

.cover {
  position: relative;
  pointer-events: none;
  overflow: hidden;
  width: 100%;

  &.enabled {
    pointer-events: all;
  }
}

.cover:before {
  position: absolute;
  content: '';
  background-color: @cover--before--background-color;
  inset: 0;
  z-index: 1;
  opacity: 0.5;
}
